// FIXME: https://github.com/nuxt/module-builder/issues/141#issuecomment-2078248248

import { addCollection } from '@iconify/vue';
import { defineNuxtPlugin } from '#imports';
import { buildEmojiCollection } from '#layers/ui/utils/emoji-collection';

const emojiCollection = buildEmojiCollection();

export default defineNuxtPlugin(() => {
	addCollection(emojiCollection);
});
